import axios from '@/utils/request';

// 获取最新百科列表
export const getKnowPoints = (data: any) => {
  return axios.request({
    url: 'KnowPoint/GetKnowPoints',
    method: 'GET',
    params: data,
  });
};

// 获取最热百科列表
export const getHotKnowPoints = (data: any) => {
  return axios.request({
    url: 'KnowPoint/GetHotKnowPoints',
    method: 'GET',
    params: data,
  });
};

// 获取百科详情
export const getKnowPointDetails = (data: any) => {
  return axios.request({
    url: 'KnowPoint/GetKnowPointDetails',
    method: 'GET',
    params: data,
  });
};
